import { getPropCacheMixin } from '../utils/cache.js';
export var ariaHidden = {
  'aria-hidden': 'true'
};
export var iconAsButton = {
  tabindex: 0,
  type: 'button',
  'aria-hidden': false,
  role: null
};
export default getPropCacheMixin('$attrs', 'qAttrs');